import state from './moduleSupplierState.js'
import mutations from './moduleSupplierMutations.js'
import actions from './moduleSupplierActions.js'
import getters from './moduleSupplierGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

